exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notification{position:relative}.notification .read,.notification .read:hover{text-decoration:underline!important}.notification span{position:absolute;top:-3px;font-size:.75rem}.notification .dropdown-menu{-webkit-transform:translate(-47%,24px)!important;transform:translate(-47%,24px)!important;max-height:310px;overflow:auto}.notification .dropdown-toggle:after{display:none}.notification .dropdown-item.active,.notification .dropdown-item:active{background-color:transparent}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cc851bda","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Header.vue
// module id = fai6
// module chunks = 1